import axios from "axios";
import apiURI from "./Api";

class ScheduleConfigService {
  async getConfig(token) {
    try {
      const response = await axios.get(`${apiURI}/schedule-config/getconfig`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error getting schedule config:", error);
      throw error;
    }
  }

  async postConfig(token, payload) {
    try {
      const response = await axios.post(`${apiURI}/schedule-config/registeredit`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error saving schedule config:", error);
      throw error;
    }
  }
}

export default ScheduleConfigService;
